function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Row, Button } from 'react-bootstrap';
import AffiliatedCompanyForm from './AffiliatedCompanyForm';
import { useTranslation } from 'react-i18next';
import affiliatedCompaniesService from '@rd-web-markets/market/dist/services/affiliated_companies.service';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { SELECTED_ROW_DIMMED_CLASS } from '../../../constants';
const AffiliateCompaniesSection = _ref => {
  let {
    elsterId
  } = _ref;
  const [selectedAffiliatedCompany, setSelectedAffiliatedCompany] = useState(null);
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [affiliatedCompanies, setAffiliatedCompanies] = affiliatedCompaniesService.useAffiliatedCompanies(elsterId);
  const deleteAffiliatedCompany = async affiliatedCompany => {
    if (window.confirm(t('are_you_sure_you_want_to_remove_this_affiliated_company'))) {
      try {
        await affiliatedCompaniesService.delete(elsterId, affiliatedCompany.id);
        setAffiliatedCompanies([...affiliatedCompanies.filter(ac => ac.id !== affiliatedCompany.id)]);
        setSelectedAffiliatedCompany(null);
      } catch (error) {
        dispatch(handleError(error));
      }
    }
  };
  const createAffiliatedCompany = () => {
    setSelectedAffiliatedCompany({});
  };
  const closeForm = () => {
    setSelectedAffiliatedCompany(null);
  };
  const handleChange = e => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setSelectedAffiliatedCompany(_objectSpread(_objectSpread({}, selectedAffiliatedCompany), {}, {
      [e.target.name]: value
    }));
  };
  const editAffiliatedCompany = (e, affiliatedCompany) => {
    e.preventDefault();
    setSelectedAffiliatedCompany(affiliatedCompany);
  };
  const handleSubmit = affiliatedCompaniesService.useSaveAffiliatedCompany(elsterId, setAffiliatedCompanies, setSelectedAffiliatedCompany);
  const AffiliatedCompanyRow = _ref2 => {
    let {
      affiliatedCompany
    } = _ref2;
    const isSelected = (selectedAffiliatedCompany === null || selectedAffiliatedCompany === void 0 ? void 0 : selectedAffiliatedCompany.id) != null && affiliatedCompany.id === selectedAffiliatedCompany.id;
    return /*#__PURE__*/React.createElement("tr", {
      key: affiliatedCompany.id,
      className: isSelected ? SELECTED_ROW_DIMMED_CLASS : ''
    }, /*#__PURE__*/React.createElement("td", null, affiliatedCompany.name), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => editAffiliatedCompany(e, affiliatedCompany)
    }, t('to_affiliate_company_details'))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      onClick: () => deleteAffiliatedCompany(affiliatedCompany),
      className: "mx-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "delete"))));
  };
  if (!affiliatedCompanies) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end pb-3"
  }, !selectedAffiliatedCompany && /*#__PURE__*/React.createElement(Button, {
    onClick: createAffiliatedCompany,
    variant: "primary",
    className: "mx-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add_new_affiliated_company'))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("table", {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("th", null, t('affiliates_name')), /*#__PURE__*/React.createElement("th", null, t('open_details')), /*#__PURE__*/React.createElement("th", null, t('delete')))), /*#__PURE__*/React.createElement("tbody", {
    className: "text-center"
  }, affiliatedCompanies.map(affiliatedCompany => /*#__PURE__*/React.createElement(AffiliatedCompanyRow, {
    affiliatedCompany: affiliatedCompany
  }))))), selectedAffiliatedCompany && /*#__PURE__*/React.createElement(AffiliatedCompanyForm, {
    handleChange: handleChange,
    affiliatedCompany: selectedAffiliatedCompany,
    closeForm: closeForm,
    handleSubmit: () => handleSubmit(selectedAffiliatedCompany, affiliatedCompanies)
  }));
};
export default AffiliateCompaniesSection;